// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".back-top[data-v-f0dea41e] {\n  position: fixed;\n  right: 4vw;\n  bottom: 20vw;\n  z-index: 999;\n}", ""]);
// Exports
module.exports = exports;
